import { useEffect, useState } from "preact/hooks";

import { getShopSettings } from "@/api";

let shopSettingsPromise = null;

const defaultShopSettings = {
  showPhotoAttachmentField: true,
  defaultReviewsSorting: "useful",
};

/**
 * @return {any}
 */
export const useShopSettings = () => {
  const [settings, setSettings] = useState(null);

  if (!shopSettingsPromise) shopSettingsPromise = getShopSettings();

  useEffect(() => {
    shopSettingsPromise.then(({ data }) => {
      const mergedSettings = { ...defaultShopSettings, ...data };
      setSettings(mergedSettings);
    });
  }, []);

  return settings;
};
